/* Homepage presentation only. The existing app remains the sole owner of box/cart mutations. */
document.addEventListener('alpine:init', () => {
  Alpine.data('tnmHomepage', () => ({
    active: 0,
    detail: '',
    guideChoice: '',
    guideStatus: 'idle',
    starterBoxes: [],
    showSticky: false,
    dialogOpen: false,
    heroObserver: null,
    guideController: null,
    get guideUrl() {
      const url = new URL(this.$root.dataset.builderUrl, window.location.origin);
      if (this.starterBoxes.some(box => box.id === this.guideChoice)) url.searchParams.set('box', this.guideChoice);
      return url.href;
    },
    move(index) {
      this.active = (index + 3) % 3;
      const track = this.$refs.track;
      const slide = track.children[this.active];
      track.scrollTo({left: slide.offsetLeft - track.children[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    },
    syncSlide() {
      const track = this.$refs.track;
      const offset = track.children[0].offsetLeft;
      let nearest = 0;
      for (let i = 1; i < track.children.length; i++) {
        if (Math.abs(track.children[i].offsetLeft - offset - track.scrollLeft) < Math.abs(track.children[nearest].offsetLeft - offset - track.scrollLeft)) nearest = i;
      }
      this.active = nearest;
    },
    openDetails(handle) {
      this.detail = handle;
      this.dialogOpen = true;
      this.$nextTick(() => this.$refs.details.showModal());
    },
    openGuide() {
      this.dialogOpen = true;
      this.$refs.guide.showModal();
      this.loadGuide();
    },
    async loadGuide() {
      if (this.guideStatus === 'loading') return;
      this.guideStatus = 'loading';
      this.starterBoxes = [];
      this.guideChoice = '';
      this.guideController = new AbortController();
      const timer = setTimeout(() => this.guideController.abort(), 8000);
      try {
        const url = new URL('/tools/custom/bundle-builder', window.location.origin);
        url.searchParams.set('handle', this.$root.dataset.builderHandle);
        url.searchParams.set('shop', this.$root.dataset.shop);
        // Share an existing native builder assignment; the builder owns creation of this cookie.
        const visitor = document.cookie.split('; ').find(row => row.startsWith('ts_bb_vid='));
        if (visitor) url.searchParams.set('vid', decodeURIComponent(visitor.slice('ts_bb_vid='.length)));
        const response = await fetch(url, {headers: {Accept: 'application/json'}, credentials: 'same-origin', cache: 'no-store', signal: this.guideController.signal});
        if (!response.ok) throw new Error('Box options unavailable');
        const payload = await response.json();
        const boxes = payload?.data?.config?.starterBoxes;
        if (payload.success !== true || payload.data.handle !== this.$root.dataset.builderHandle || !Array.isArray(boxes) || !boxes.length) throw new Error('Box options unavailable');
        const ids = new Set();
        this.starterBoxes = boxes.map(box => {
          if (typeof box.id !== 'string' || !box.id.trim() || ids.has(box.id) || typeof box.label !== 'string' || !box.label.trim() || !Array.isArray(box.lines) || !box.lines.length || box.lines.some(line => !line.variantId || !Number.isInteger(line.quantity) || line.quantity < 1)) throw new Error('Box options unavailable');
          ids.add(box.id);
          return {id: box.id, label: box.label};
        });
        this.guideStatus = 'ready';
      } catch {
        this.starterBoxes = [];
        this.guideStatus = 'error';
      } finally {
        clearTimeout(timer);
      }
    },
    closeDialog(ref) { this.$refs[ref].close(); },
    init() {
      if ('IntersectionObserver' in window && this.$refs.hero) {
        this.heroObserver = new IntersectionObserver(([entry]) => {
          this.showSticky = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        });
        this.heroObserver.observe(this.$refs.hero);
      }
      // A cancelled dialog returns focus to its opener using the browser's native dialog behavior.
      this.$watch('detail', () => { if (this.$refs.details) this.$refs.details.scrollTop = 0; });
    },
    destroy() {
      this.heroObserver?.disconnect();
      this.guideController?.abort();
    }
  }));
});
